var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-list-item",
    {
      directives: [
        {
          name: "ripple",
          rawName: "v-ripple",
          value: { class: "primary--text" },
          expression: "{class: 'primary--text'}",
        },
      ],
      staticClass: "text-18 pl-6",
      attrs: {
        href: _vm.href,
        rel: _vm.href && _vm.href !== "#" ? "noopener" : undefined,
        target: _vm.href && _vm.href !== "#" ? "_blank" : undefined,
        to: _vm.item.to,
        "active-class": ` ${
          _vm.isDark ? " grey--text text--lighten-5" : "primary--text"
        }`,
        height: 48,
      },
    },
    [
      _vm.text
        ? _c("v-list-item-icon", { staticClass: "v-list-item__icon--text" }, [
            _vm._v(" " + _vm._s(_vm.computedText) + " "),
          ])
        : _vm.item.icon
        ? _c(
            "v-list-item-icon",
            [_c("v-icon", [_vm._v(_vm._s(_vm.item.icon))])],
            1
          )
        : _vm._e(),
      _vm.item.title || _vm.item.subtitle
        ? _c(
            "v-list-item-content",
            { staticClass: "pa-0 text-14", attrs: { c: "" } },
            [
              _c("v-list-item-title", { staticClass: "ma-0 text-14" }, [
                _vm._v(" " + _vm._s(_vm.item.title) + " "),
              ]),
              _c("v-list-item-subtitle", [
                _vm._v(" " + _vm._s(_vm.item.subtitle) + " "),
              ]),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }